import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import curbsideAPIService from '../services/curbsideAPIService';

export const fetchDashboardData = createAsyncThunk('dashboard/fetchDashboardData', async ({ sortConfig, storeId }: { sortConfig?: { key: string; direction: string }; storeId: string }) => {
  const endpoint = 'dashboard';
  const data = {
    sortBy: sortConfig?.key ?? 'orderReference',
    sortDirection: sortConfig?.direction ?? 'asc',
    storeId: storeId,
  };
  const response = await curbsideAPIService.post(endpoint, data);
  return response; // Ensure returning actual data
});

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    data: null, // Store fetched data
    sortConfig: { key: 'orderReference', direction: 'asc' },
    isLoading: true,
    error: null as string | null, // Track errors
  },
  reducers: {
    setSortConfig: (state, action) => {
      state.sortConfig = action.payload; // Update sort configuration
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.isLoading = true;
        state.error = null; // Reset error on new request
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.data = action.payload; // Update with API response
        state.isLoading = false;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message ?? null; // Capture error message or set to null
      });
  },
});

export const { setSortConfig } = dashboardSlice.actions;
export default dashboardSlice.reducer;
